import { compare } from 'compare-versions'

const params = new URLSearchParams(location.search)

export const appVersion = params.get('app_version')

export const isValidAppVersion = compare(appVersion ?? '0.0.0', '5.13.0', '>=')

export const language = params.get('language') ?? 'en'

export const timestamp = new Date(Number(params.get('ts')) * 1000)

export const shouldMockAPI = params.has('mock')

export type Platform = 'ios' | 'googleplay_android' | 'china_android'

export const platform = params.get('platform') as Platform
